import {
  OWNER_REGISTER_REQUEST,
  OWNER_REGISTER_SUCCESS,
  OWNER_REGISTER_FAIL,
  OWNER_REGISTER_RESET,
  OWNER_LOGIN_REQUEST,
  OWNER_LOGIN_SUCCESS,
  OWNER_LOGIN_FAIL,
  OWNER_LOGIN_RESET,
  OWNER_DETAILS_REQUEST,
  OWNER_DETAILS_SUCCESS,
  OWNER_DETAILS_FAIL,
  OWNER_DETAILS_RESET,
  OWNER_PROFILE_REQUEST,
  OWNER_PROFILE_SUCCESS,
  OWNER_PROFILE_FAIL,
  OWNER_UPDATE_PROFILE_REQUEST,
  OWNER_UPDATE_PROFILE_SUCCESS,
  OWNER_UPDATE_PROFILE_FAIL,
  OWNER_UPDATE_PROFILE_RESET
} from '../constants/ownerConstants'

// Reducer for managing owner registration state, handling loading, success, and error states based on dispatched actions.
export const ownerRegisterReducer = (state = {}, action) => {
  switch (action.type) {
    case OWNER_REGISTER_REQUEST:
      return { loading: true }
    case OWNER_REGISTER_SUCCESS:
      return { loading: false, ownerInfo: action.payload }
    case OWNER_REGISTER_FAIL:
      return { loading: false, error: action.payload }
    case OWNER_REGISTER_RESET:
      return {}
    default:
      return state
  }
}

// Reducer for managing owner login state, handling loading, success, error, and reset states based on dispatched actions.
export const ownerLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case OWNER_LOGIN_REQUEST:
      return { loading: true }
    case OWNER_LOGIN_SUCCESS:
      return { loading: false, ownerInfo: action.payload }
    case OWNER_LOGIN_FAIL:
      return { loading: false, error: action.payload }
    case OWNER_LOGIN_RESET:
      return {}
    default:
      return state
  }
}

// Reducer for managing owner details state, handling loading, success, and error states based on dispatched actions.
export const ownerDetailsReducer = (state = { owner: {} }, action) => {
  switch (action.type) {
    case OWNER_DETAILS_REQUEST:
      return { ...state, loading: true }
    case OWNER_DETAILS_SUCCESS:
      return { loading: false, owner: action.payload }
    case OWNER_DETAILS_FAIL:
      return { loading: false, error: action.payload }
    case OWNER_DETAILS_RESET:
      return { owner: {} }
    default:
      return state
  }
}

export const ownerProfileReducer = (state = { owner: {} }, action) => {
  switch (action.type) {
    case OWNER_PROFILE_REQUEST:
      return { ...state, loading: true }
    case OWNER_PROFILE_SUCCESS:
      return { loading: false, owner: action.payload }
    case OWNER_PROFILE_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const ownerUpdateProfileReducer = (state = {}, action) => {
  switch (action.type) {
    case OWNER_UPDATE_PROFILE_REQUEST:
      return { loading: true }
    case OWNER_UPDATE_PROFILE_SUCCESS:
      return { loading: false, success: true, ownerInfo: action.payload }
    case OWNER_UPDATE_PROFILE_FAIL:
      return { loading: false, error: action.payload }
    case OWNER_UPDATE_PROFILE_RESET:
      return {}
    default:
      return state
  }
}
